import { Modal, Descriptions } from 'antd';
import styled from 'styled-components';
import { Title } from '@/components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const StyledModal = styled(Modal)`
  &.ant-modal {
    top: 56px;

    .ant-modal-content {
      display: flex;
      flex-direction: column;
      height: 85vh;
      max-height: 788px;

      .ant-modal-body {
        display: flex;
        flex-grow: 1;

        .ant-form {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
`;

/** Bordered plan summary grid in the details header. */
export const PlanSummaryTable = styled(Descriptions)`
  width: 100%;

  &.ant-descriptions-bordered .ant-descriptions-view {
    border: 1px solid rgba(${APP_SHELL_THEME.overlayRgb}, 0.9) !important;
    border-radius: 4px;
    overflow: hidden;
  }

  .ant-descriptions-item-label {
    font-size: 12px;
    font-weight: 700;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.88);
    width: 11%;
    min-width: 108px;
    white-space: nowrap;
    vertical-align: top;
    padding: 8px 12px !important;
  }

  .ant-descriptions-item-content {
    font-size: 13px;
    font-weight: 400;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
    vertical-align: top;
    padding: 8px 12px !important;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    width: 1%;
  }

  .ant-descriptions-row > th,
  .ant-descriptions-row > td {
    border-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.22) !important;
  }
`;

export const GrossProfitValue = styled.span`
  color: #95de64;
  font-weight: 400;
`;

export const AllocatedBudgetValue = styled.span<{ $isUnderAllocated: boolean; $isOverAllocated?: boolean }>`
  color: ${({ $isUnderAllocated, $isOverAllocated }) => {
    if ($isOverAllocated || $isUnderAllocated) return '#ff7875';
    return '#95de64';
  }};
  font-weight: 400;
`;

export const StyledTitle = styled(Title)`
  max-width: 920px;
`;

export const ChannelsBudget = styled.span<{ isError: boolean }>`
  position: absolute;
  bottom: -5px;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ theme, isError }) => (isError ? theme.color.dust_red_4 : `rgba(${APP_SHELL_THEME.overlayRgb}, 0.88)`)};
  font-weight: ${({ isError }) => (isError ? 700 : 500)};
`;
